import React from "react";
import { Link } from "react-router-dom";

export default function ProgramsSection({ data }) {
  return (
    <section className="institution-programs-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="institution-programs-section-heading text-center">
              <span className="main-title">{data.eyebrow}</span>
              <h2 className="heading text-white text-capitalize">{data.title}</h2>
              <p className="text-white">{data.description}</p>
            </div>
          </div>
        </div>

        <div className="row institution-programs-section-cards">
          {data.items.map((program) => (
            <div className="col-lg-4" key={program.label}>
              <article className="institution-program-card">
                <img
                  src={program.image}
                  alt={program.imageAlt}
                  className="img-responsive institution-program-card-image"
                />
                <div className="institution-program-card-content">
                  <span className="institution-program-card-label">{program.label}</span>
                  <h3>{program.title}</h3>
                  <p>{program.description}</p>
                  <Link to={program.to}>
                    {program.linkLabel} <i className="fa-solid fa-arrow-right" />
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
